// Landing pages
export const LANDING = '/';
export const WINNERS = '/ganadores';
export const PARTICIPATING_STATIONS = '/estaciones-participantes';
export const FAQ = '/faq';

// Authentication routes
export const LOGIN = '/iniciar-sesion';
export const LOGIN_PASSWORD = '/iniciar-sesion/password';
export const ACCEPT_TERMS = '/aceptar-terminos-y-condiciones';
export const REGISTER = '/registro';
export const SOCIAL_REGISTER = '/registro/social';
export const RESET_PASSWORD = '/reiniciar-contrasena';
export const RESTORE_PASSWORD = '/restablecer-contrasena';
export const AUTH_RESET_PASSWORD = '/authentication/reset-password';
export const AUTH_CREATE_TOKENS = '/authentication/create-tokens';
export const AUTH_CALLBACK = '/auth/callback';
export const LOGOUT = '/cerrar-sesion';

// Dashboard and main routes
export const DASHBOARD = '/dashboard';
export const CONFIGURE_PROFILE = '/configurar-perfil';
export const PERSONAL_DATA = '/datos-personales';
export const PROFILE = '/perfil';

// QR and codes routes
export const SCAN_QR = '/escanear-qr';
export const QR_VALIDATION = '/qr-validation';
export const QR_PROCESS = '/procesar-qr';
export const QR_REDEEMED = '/qr-canjeado';
export const QR_PATH = '/qr';
export const QR_WITH_CODE = '/qr/:code';
export const EXTERNAL_QR = '/_qr/:id';

// Exchange routes
export const EXCHANGE_CODES = '/canjear-cupon';
export const EXCHANGE_FROM_CODE_IN_PATH = '/ingresar-codigos';
export const DATA_VOUCHER = '/data-voucher';

// Giveaway routes
export const GIVEAWAY_WINNER = '/ganador-sorteo';

// Legal pages routes
export const TERMS_CONDITIONS = '/terminos-condiciones';
export const PRIVACY_POLICY = '/politica-datos';

// Other routes
export const ERROR = '/error';
export const PRIVACY_POLICIES = '/politicas-de-privacidad-plain-text';
export const NOT_FOUND = '*';
